import script from "./CustomModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomModal.vue?vue&type=style&index=0&id=6a58cff7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a58cff7"]])

export default __exports__